<button class="btn btn--xs btn--primary" (click)="displayConvertToProjectModal = true">
  {{ 'EVENT.convert_to_project' | translate }}
</button>

<p-dialog
  [(visible)]="displayConvertToProjectModal"
  [dismissableMask]="true"
  [modal]="true"
  (onHide)="displayConvertToProjectModal = false"
  [style]="{ width: '600px' }"
>
  <div style="padding: 40px 80px">
    <div class="modal__wrapper">
      <div class="modal__title">
        {{ 'EVENT.convert_to_project' | translate }}
      </div>
      <div class="modal__description">
        <div>
          {{ 'EVENT.are_you_sure_to_convert' | translate }}
        </div>
      </div>
      <div class="modal__actions">
        <button
          class="btn btn--outline btn--md mw-160"
          (click)="displayConvertToProjectModal = false"
        >
          {{ 'GLOBAL.cancel' | translate }}
        </button>
        <button class="btn btn--success btn--md mw-160" (click)="convertToProject()">
          {{ 'EVENT.convert' | translate }}
        </button>
      </div>
    </div>
  </div>
</p-dialog>
